/* src/app/private/components/dialing-group/bulk-import-dialing-content/bulk-import-dialing-content.component.scss */
.text-danger {
  font-size: 12px;
  margin-top: 2px;
  color: red;
}
.fields {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.drop-zone {
  width: 100%;
}
.drop-zone ::ng-deep .p-fileupload {
  width: 100%;
  min-width: 300px;
}
.drop-zone ::ng-deep .p-fileupload .p-fileupload-content {
  padding: 2rem;
  border: 2px dashed #dee2e6;
  border-radius: 6px;
  transition: all 0.3s ease;
  background-color: #f8fafc;
}
.drop-zone ::ng-deep .p-fileupload .p-fileupload-content:hover {
  border-color: #3B82F6;
  background-color: #f0f7ff;
}
.drop-zone ::ng-deep .p-fileupload .upload-text {
  text-align: center;
  color: #64748b;
  margin: 1rem 0;
}
:host ::ng-deep .p-fileupload-choose {
  display: none !important;
}
:host ::ng-deep .custom-upload {
  width: 100%;
}
:host ::ng-deep .custom-upload .p-button-icon-only {
  padding: 0.5rem;
}
/*# sourceMappingURL=bulk-import-dialing-content.component.css.map */
